export const FlightTypes = {
    Arrival: 'arrival',
    Departure: 'departure',
};

export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_SELECTED_TYPE = 'SET_SELECTED_TYPE';
export const SET_FLIGHTS = 'SET_FLIGHTS';
export const SET_SELECTED_AIRPORT = 'SET_SELECTED_AIRPORT';
